// `.env.ts` is generated by the `npm run env` command
import { env } from './.env';

export const environment = {
  production: true,
  version: env.npm_package_version + '-devcx',
  appVersion: require('../../package.json').version,
  apiUrl: 'https://devcx.reflecx.io/app',
  serverUrl: '/api',
  apiVersion: '/v1',
  defaultLanguage: 'en-CA',
  hmr: false,
  logs: false,
  reflecxRoutePrefix: 'composer', // admin, '', admin
  reportingRoutePrefix: 'insights', // reporting, reporting, ''
  defaultAppRoute: 'insights', // reporting, datasource, globaldashboard
  Apps: { ReflecxApp: true, ReportingApp: true },
  baseLine: false,
  cacheDb: 'MyApp',
  engineUrl: `${(window as any).baseUrl}/responses/`,
  libraryPath: '/library/',
  FilePath: '/Uploads/',
  directorySeparator: '/',
  fromEmailAddress: ['survey@epanelprogram.toyotaexperience.ca'],
  dateFormat: 'LLL dd, yyyy, hh:mm:ss aa',
  signalRConfigured: true,
  signalRUrl: 'https://devcx.reflecx.io/app/RealTimeNotificationHub',
  loaderStyle: 'main',
  printServerUrl: 'https://devcx.reflecx.io/print',
  crosstabApiUrl: 'https://devcx.reflecx.io/crosstabs_api/',
  isPrintAllowed: true,
  defaultMarketLanguage: 'en-CA',
  NotificationSetting: {
    notificationSessionTimeoutMinutes: 30,
    notificationUpdateInterval: 30000,
  },
  login: {
    isDefaultEnabled: false,
    defaultRoute: '/login/:id',
    defaultRouteValue: 'utility',
  },
  whitelabelledDomains: [
    {
      domain: 'https://ccacustomerserviceexperience.com',
      realm: 'prod-hca',
    },
    {
      domain: 'https://nissancustomervoice.com',
      realm: 'prod-nci',
    },
    {
      domain: 'https://echoparkfeedback.com',
      realm: 'prod-reflecx',
    },
    {
      domain: 'https://smithvillefeedback.com',
      realm: 'prod-reflecx',
    },
    {
      domain: 'https://reflecx.io',
      realm: 'prod-reflecx',
    },
    {
      domain: 'https://epanel.toyotaexperience.ca',
      realm: 'prod-reflecx',
    },
    {
      domain: 'https://infinitiguestexperience.nnanet.com',
      realm: 'prod-infiniti',
    },
    {
      domain: 'https://infiniti-prod.reflecx.io',
      realm: 'prod-infiniti',
    },
    {
      domain: 'https://tci.reflecx.io',
      realm: 'prod-tci',
    },
    {
      domain: 'https://lci.reflecx.io',
      realm: 'prod-lci',
    },
    {
      domain: 'https://toyotaexperience.ca',
      realm: 'prod-tci',
    },
    {
      domain: 'https://lexusexperience.ca',
      realm: 'prod-lci',
    },
  ],
  epanelSsoUrl: 'https://epanel.toyotaexperience.ca/portal',
};
export const keycloakAngularConfig = {
  authority: 'https://staging-identity.reflecx.io',
  // authority: 'https://staging.ccacustomerserviceexperience.com',
  portalUrl: 'http://localhost:4200',
  // realm: 'hca',
  realm:
    environment.whitelabelledDomains.find((x) => x.domain === window.location.origin)?.realm != null &&
    environment.whitelabelledDomains.find((x) => x.domain === window.location.origin)?.realm != undefined
      ? environment.whitelabelledDomains.find((x) => x.domain === window.location.origin)?.realm
      : 'devcx-reflecx', // set this 'prod-nci' for Nissan and 'prod-hca' for HCA client 'sandbox-reflecx'  sandbox-epanel
  clientId: 'angular-client',
  redirectUri: window.location.href,
  silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
  enableLogging: true,
  checkLoginIframe: false,
  clockSkew: 86400,
};
//// IdentityServer Angular Client Configuration
//export const identityServerAngularConfig = {
//  authority: 'https://devcx.reflecx.io/identity',
//  client_id: 'local-angular',
//  redirect_uri: 'https://devcx.reflecx.io/portal/callback.html',
//  response_type: 'code',
//  scope: 'openid profile email api1 offline_access',
//  post_logout_redirect_uri: 'https://devcx.reflecx.io/portal/signout-callback.html',
//  silent_redirect_uri: 'https://devcx.reflecx.io/portal/renew-callback.html',
//  accessTokenExpiringNotificationTime: 300,
//  automaticSilentRenew: true,
//  clockSkew: 86400
//};

// IdentityServer Angular Client Configuration
export const identityServerAngularConfig = Object.assign({}, (window as any).bootstrapSettings);

// IdentityServer TCI SSO Configuration
export const identityServerTCIConfig = {
  authority: 'https://devcx.reflecx.io/account',
  client_id: 'tci.rop.client',
  scope: 'api1',
  secret: 'secret',
};

// IdentityServer SSO Configuration
export const identityServerSSOConfig = {
  authority: (window as any).baseUrl + '/accounts',
  client_id: 'external.saml',
  redirect_uri: (window as any).baseUrl + '/portal/extcallback.html',
  response_type: 'code',
  scope: 'openid profile email api1 offline_access',
  post_logout_redirect_uri: (window as any).baseUrl + '/portal/ext-signout-callback',
  silent_redirect_uri: (window as any).baseUrl + '/portal/silent-callback.html',
  accessTokenExpiringNotificationTime: 300,
  automaticSilentRenew: true,
  clockSkew: 86400,
};
export const apiURL = 'https://inteliq.io/demoapi';
export const staticUrl = 'https://clearviewprodemo.com';
export const QNAAPIURL = 'http://172.21.3.198:8015/qa_service/';
export const pipelineData = {
  Comment_Type: 'social_media',
  TopNCategories: '3',
  ModelFilesPath: '/data/E_Drive/All_Models/cross_lingual_models',
  BatchSizetoProcess: '1000',
  ClientCode: 'Acura',
  IS_DEBUG: 'False',
  Client_Name_Masking: 'Toyota',
};
